import { render, staticRenderFns } from "./SectionWork.vue?vue&type=template&id=f29792f2&"
import script from "./SectionWork.vue?vue&type=script&lang=js&"
export * from "./SectionWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports